import { GetDriversResponse } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import axios from './axios';

export const getDriversForPolicy = async (policyNumber?: string) => {
  if (!policyNumber) {
    return Promise.reject(new Error('Missing policyNumber'));
  }

  const { data } = await axios.get<GetDriversResponse>(
    `${
      import.meta.env.VITE_POLICIES_API_URL
    }/v1/policies/${policyNumber}/drivers`,
    {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    }
  );

  return data;
};

export const useDriversForPolicyQuery = (policyNumber?: string) =>
  useQuery({
    queryKey: ['drivers', policyNumber],
    queryFn: () => getDriversForPolicy(policyNumber),
    enabled: !!policyNumber,
    staleTime: 1000 * 60 * 10,
  });
